import { LogOut, Mail, User, Car, Plus } from 'lucide-react';
// Logo images
const logoWhite = "/Logos/Sayaara White Logo.png";
import { Button } from '../ui/button';
import { DEALER_NAVIGATION_ITEMS } from '../../constants/dealership';

interface NavigationBarProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
  onContactClick: () => void;
  onLogout: () => void;
}

export function NavigationBar({ 
  activeSection, 
  onSectionChange, 
  onContactClick, 
  onLogout 
}: NavigationBarProps) {
  return (
    <nav className="bg-white shadow-lg border-b border-gray-200 sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <div className="flex-shrink-0">
              <img 
                src={logoWhite} 
                alt="Sayaara Dealer Portal" 
                className="h-10 w-auto" 
              />
            </div>
            
            <div className="hidden md:flex items-center space-x-4">
              {DEALER_NAVIGATION_ITEMS.map((item) => (
                <button
                  key={item.id}
                  onClick={() => onSectionChange(item.id)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    activeSection === item.id
                      ? 'bg-[#f91bdc] text-white'
                      : 'text-gray-600 hover:text-[#f91bdc] hover:bg-[#f91bdc]/10'
                  }`}
                >
                  <div className="flex items-center space-x-2">
                    {item.iconName === 'User' && <User size={16} />}
                    {item.iconName === 'Car' && <Car size={16} />}
                    {item.iconName === 'Plus' && <Plus size={16} />}
                    <span>{item.name}</span>
                  </div>
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <Button 
              variant="outline" 
              size="sm"
              onClick={onContactClick}
              className="hidden sm:flex border-[#f91bdc] text-[#f91bdc] hover:bg-[#f91bdc] hover:text-white"
            >
              <Mail size={16} className="mr-2" />
              Contact Support
            </Button>
            
            <Button 
              variant="destructive" 
              size="sm"
              onClick={onLogout}
              className="bg-red-500 hover:bg-red-600"
            >
              <LogOut size={16} className="mr-2" />
              Logout
            </Button>
          </div>
        </div>

        {/* Mobile navigation */}
        <div className="md:hidden border-t border-gray-200 py-2">
          <div className="flex space-x-1 overflow-x-auto">
            {DEALER_NAVIGATION_ITEMS.map((item) => (
              <button
                key={item.id}
                onClick={() => onSectionChange(item.id)}
                className={`flex-shrink-0 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  activeSection === item.id
                    ? 'bg-[#f91bdc] text-white'
                    : 'text-gray-600 hover:text-[#f91bdc] hover:bg-[#f91bdc]/10'
                }`}
              >
                <div className="flex items-center space-x-2">
                  {item.iconName === 'User' && <User size={16} />}
                  {item.iconName === 'Car' && <Car size={16} />}
                  {item.iconName === 'Plus' && <Plus size={16} />}
                  <span>{item.name}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}